import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { AdminFragrances, AdminDecants } from "@/pages/admin/AdminCatalog";
import { AdminJournal, AdminFaq, AdminPolicies, AdminStory, AdminContact, AdminHero, AdminSignups, AdminOrders, AdminStoryCards, AdminReviews } from "@/pages/admin/AdminContent";

const tabs = ["Orders", "Reviews", "Fragrances", "Decants", "Journal", "FAQ", "Policies", "Story", "Contact", "Hero", "Signups", "Story Cards"];

const formatErr = (d) => {
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return "Something went wrong";
};

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("be_admin_token", data.token);
      onLogin(data.email);
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <form onSubmit={submit} className="w-full max-w-sm border border-[#2B2118]/10 p-10 bg-[#DDD3C1]">
        <p className="font-display text-2xl text-[#2B2118]">Bonheur Eternal</p>
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#8F6B3A] mt-1 mb-8">Admin — The House</p>
        <input data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email"
          className="w-full bg-transparent border-b border-[#2B2118]/20 pb-2 mb-6 text-sm outline-none focus:border-[#8F6B3A] text-[#2B2118] placeholder:text-[#6E6151]" />
        <input data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password"
          className="w-full bg-transparent border-b border-[#2B2118]/20 pb-2 mb-6 text-sm outline-none focus:border-[#8F6B3A] text-[#2B2118] placeholder:text-[#6E6151]" />
        {error && <p data-testid="admin-login-error" className="text-xs text-red-400 mb-4">{error}</p>}
        <button data-testid="admin-login-btn" type="submit" className="w-full bg-[#8F6B3A] text-[#FBF8F1] py-3 text-xs tracking-[0.2em] uppercase font-medium hover:bg-[#6F5433] transition-colors">
          Enter
        </button>
      </form>
    </div>
  );
};

export default function AdminPage() {
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);
  const [tab, setTab] = useState("Fragrances");

  useEffect(() => {
    document.title = "Admin — Bonheur Eternal";
    api.get("/auth/me").then((r) => setUser(r.data.email)).catch(() => {}).finally(() => setChecked(true));
  }, []);

  if (!checked) return <div className="min-h-screen bg-[#CFC2AC]" />;
  if (!user) return <Login onLogin={setUser} />;

  return (
    <div className="min-h-screen bg-[#CFC2AC] text-[#2B2118]">
      <header className="border-b border-[#2B2118]/10 px-6 py-4 flex items-center justify-between sticky top-0 bg-[#CFC2AC]/90 backdrop-blur z-40">
        <div>
          <span className="font-display text-lg">Bonheur Eternal</span>
          <span className="ml-2 text-[10px] tracking-[0.3em] uppercase text-[#8F6B3A]">Admin</span>
        </div>
        <div className="flex items-center gap-4 text-xs text-[#6E6151]">
          <a href="/" className="hover:text-[#8F6B3A]" data-testid="admin-view-site">View site</a>
          <button data-testid="admin-logout-btn" onClick={() => { localStorage.removeItem("be_admin_token"); setUser(null); }} className="hover:text-[#8F6B3A]">
            Sign out
          </button>
        </div>
      </header>
      <div className="flex flex-wrap gap-2 px-6 py-4 border-b border-[#2B2118]/10">
        {tabs.map((t) => (
          <button key={t} data-testid={`admin-tab-${t.toLowerCase()}`} onClick={() => setTab(t)}
            className={`px-4 py-2 text-xs tracking-[0.15em] uppercase border transition-colors ${tab === t ? "border-[#8F6B3A] text-[#8F6B3A]" : "border-[#2B2118]/10 text-[#6E6151] hover:text-[#2B2118]"}`}>
            {t}
          </button>
        ))}
      </div>
      <div className="p-6 max-w-5xl">
        {tab === "Orders" && <AdminOrders />}
        {tab === "Reviews" && <AdminReviews />}
        {tab === "Fragrances" && <AdminFragrances />}
        {tab === "Decants" && <AdminDecants />}
        {tab === "Journal" && <AdminJournal />}
        {tab === "FAQ" && <AdminFaq />}
        {tab === "Policies" && <AdminPolicies />}
        {tab === "Story" && <AdminStory />}
        {tab === "Contact" && <AdminContact />}
        {tab === "Hero" && <AdminHero />}
        {tab === "Signups" && <AdminSignups />}
        {tab === "Story Cards" && <AdminStoryCards />}
      </div>
    </div>
  );
}
